import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import coupleImage from '../../../assets/images/couples/Vector.png';
import { LoginContext } from '../../../context/LoginContext';
import Header from '../../profiles/Header';
import Footer from '../../Footer';


const EditProfile = () => {
  // Form data state


  const navigate = useNavigate();
  const param = useParams();
  const { userData, userName, userId, isLoggedIn } = useContext(LoginContext);
  const [APIformData, setAPIFormData] = useState({});



  const [formData, setFormData] = useState({
    description: '',
    subcaste: "",
    currentlocation: '',
    country: '',
    manglik: "",
    maritalStatus: "",
    height: '',
    weight: "",
    bodyType: "",
    physicalStatus: "",
    eatingHabits: "",
    drinkingHabits: "",
    smokingHabits: "",
    hobbies: "",
    highestEducation: "",
    educationQualification: "",
    occupation: "",
    employedIn: "",
    annualIncome: "",
    organizationName: "",
    caste: "",
    sisters: "",
    brothers: "",
    gothra: '',
    maternalGothra: '',
    familyStatus: "",
    familyType: "",
    familyBelongsTo: "",
    livingWithParents: "",
    state: "",
    city: "",
    pincode: "",
  });


  // const [formData, setFormData] = useState({
  //   description: `Hello, I am ${userData.name ? userData.name : "Hindu Sanjogian"}. Welcome to my profile. I am ${APIformData.age} years old. My height is ${APIformData.height}. This profile is created by ${APIformData.profileFor}. My mother tongue is ${APIformData.language}. I belong to a ${APIformData.family_type}. I am a ${APIformData.highest_education} and ${APIformData.occupation} by Profession. My hobbies are ${APIformData?.hobbies?.map((val, i) => ((i == 0) ? (val) : (` ${val}`)))}. If you like my profile let's connect further on HinduSanjog. Thank you 😊..`,
  //   subcaste: "",
  //   currentlocation: { label: "India", value: "India" },
  //   country: APIformData.country ? { label: APIformData.country, value: APIformData.country } : { label: "India", value: "India" },
  //   manglik: "",
  //   maritalStatus: "",
  //   height: APIformData.height ? { label: APIformData.height, value: APIformData.height } : "",
  //   weight: "",
  //   bodyType: "",
  //   physicalStatus: "",
  //   eatingHabits: "",
  //   drinkingHabits: "",
  //   smokingHabits: "",
  //   hobbies: APIformData.hobbies ? APIformData?.hobbies?.map(sel => ({ label: sel, value: sel })) : "",
  //   highestEducation: APIformData.highest_education ? { label: APIformData.highest_education, value: APIformData.highest_education } : "",
  //   educationQualification: "",
  //   occupation: APIformData.occupation ? { label: APIformData.occupation, value: APIformData.occupation } : "",
  //   employedIn: "",
  //   annualIncome: "",
  //   organizationName: "",
  //   caste: null,
  //   sisters: "",
  //   brothers: "",
  //   gothra: null,
  //   maternalGothra: null,
  //   familyStatus: "",
  //   familyType: APIformData.family_type ? { label: APIformData.family_type, value: APIformData.family_type } : "",
  //   familyBelongsTo: "",
  //   livingWithParents: "",
  //   state: APIformData.state ? { label: APIformData.state, value: APIformData.state } : "",
  //   city: null,
  //   pincode: ""
  // });

  // Options data state

  const [options, setOptions] = useState({
    caste: [],
    gothra: [],
    cities: [],
    countries: [],
    income: [],
    language: [],
    states: [],
    education: [],
    occupation: []
  });

  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({});


  // Fetch all dropdown options
  useEffect(() => {

    if (!isLoggedIn) {
      navigate("/login");
    }

    const payload = new FormData();
    payload.append("id", userId);
    payload.append("looking", userData.looking_for);
    payload.append("gender", userData.gender);
    payload.append("status", userData.status);
    payload.append("email", userData.email);
    payload.append("find_id", param.id);


    const fetchOptions = async () => {
      try {
        setIsLoading(true);
        setErrors({});

        if (param.id === userId) {

          axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/view_profile`, payload)
            .then(response => {
              setAPIFormData(response.data.details);
              let data = response.data.details;
              setFormData({
                description: data.desc,
                subcaste: data.sub_caste,
                currentlocation: data.curr_location,
                country: data.country,
                manglik: data.manglik,
                maritalStatus: data.marital_status,
                height: data.height,
                weight: data.weight,
                bodyType: data.bdy_type,
                physicalStatus: data.ps,
                eatingHabits: data.eating,
                drinkingHabits: data.drinking,
                smokingHabits: data.smoking,
                hobbies: data.hobbies,
                highestEducation: data.highest_edu,
                educationQualification: data.ug_degree,
                occupation: data.occupation,
                employedIn: data.emp_in,
                annualIncome: data.annual_income,
                organizationName: data.org_name,
                caste: data.caste,
                brothers: data.brother,
                sisters: data.sister,
                gothra: data.gothra,
                maternalGothra: data.gothra_maternal,
                familyStatus: data.family_status,
                familyType: data.family_type,
                familyBelongsTo: data.family_based,
                livingWithParents: data.living_wth_parents,
                state: data.state,
                city: data.city,
                pincode: data.pin,
              });
            })
            .catch(error => {
              console.error("There was an error fetching users!", error);
            });

        }






        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`
        );

        const resp = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}admin-mat/api/education.php`
        );


        if (!response.data.success) {
          throw new Error(response.data.error || "Failed to fetch options");
        }


        // Transform all options to ensure they're arrays
        const transformedOptions = {
          caste: Array.isArray(response.data.data.caste) ? response.data.data.caste : [],
          gothra: Array.isArray(response.data.data.gothra) ? response.data.data.gothra : [],
          cities: Array.isArray(response.data.data.cities) ? response.data.data.cities : [],
          countries: Array.isArray(response.data.data.countries) ? response.data.data.countries : [],
          income: Array.isArray(response.data.data.income) ? response.data.data.income : [],
          language: Array.isArray(response.data.data.message) ? response.data.data.message : [],
          states: Array.isArray(response.data.data.states) ? response.data.data.states : [],
          subCaste: Array.isArray(response.data.data.subcaste) ? response.data.data.subcaste : [],
          education: Array.isArray(resp.data.data.education) ? resp.data.data.education : [],
          occupation: Array.isArray(resp.data.data.occupation) ? resp.data.data.occupation : []
        };

        setOptions(transformedOptions);
      } catch (err) {
        console.error("Error fetching options:", err);
        setErrors(err.message);
        // Initialize with empty arrays if request fails
        setOptions({
          caste: [],
          gothra: [],
          cities: [],
          countries: [],
          income: [],
          language: [],
          states: [],
          subCaste: [],
          education: [],
          occupation: []
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchOptions();
  }, [param.id]);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));


    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

  };


  // Handle select changes
  const handleSelectChange = (name, selectedOption) => {
    setFormData(prev => ({
      ...prev,
      [name]: selectedOption
    }));

  };



  const validateForm = () => {
    /////after Fill Validate form
    const newErrors = {};

    if (!formData.description.trim()) newErrors.description = "Description is Required";
    if (!formData.subcaste) newErrors.subcaste = "Sub Caste Is Required";
    if (!formData.currentlocation) newErrors.currentlocation = "Please Select Current location";
    if (!formData.manglik) newErrors.manglik = "Manglik is Required";
    if (!formData.maritalStatus) newErrors.maritalStatus = "Martial Status is Required";
    if (!formData.height) newErrors.height = "Height is Required";
    if (!formData.weight) newErrors.weight = "Weight is Required";
    if (!formData.bodyType) newErrors.bodyType = "Body Type is Required";
    if (!formData.physicalStatus) newErrors.physicalStatus = "Physical Status is Required";
    if (!formData.eatingHabits) newErrors.eatingHabits = "Eating Habits is Required";
    if (!formData.drinkingHabits) newErrors.drinkingHabits = "Drinking Habits is Required";
    if (!formData.smokingHabits) newErrors.smokingHabits = "Somking is Required";
    if (formData.hobbies.length < 1) newErrors.hobbies = "Hobbies are Required";
    if (!formData.highestEducation) newErrors.highestEducation = "Highest Education is Required";
    if (!formData.educationQualification) newErrors.educationQualification = "Education Qualification is Required";
    if (!formData.occupation) newErrors.occupation = "Occupation is Required";
    if (!formData.employedIn) newErrors.employedIn = "Employed In is Required";
    if (!formData.annualIncome) newErrors.annualIncome = "Annual Income is Required";
    if (!formData.sisters) newErrors.sisters = "Sister(s) is Required";
    if (!formData.brothers) newErrors.brothers = "Brother(s) is Required";
    if (!formData.gothra) newErrors.gothra = "Gothra is Required";
    if (!formData.maternalGothra) newErrors.maternalGothra = "Maternal Gothra is Required";
    if (!formData.familyStatus) newErrors.familyStatus = "Family Status is Required";
    if (!formData.familyBelongsTo) newErrors.familyBelongsTo = "Family Belongs To is Required";
    if (!formData.familyType) newErrors.familyType = "Familty Type is Required";
    if (!formData.livingWithParents) newErrors.livingWithParents = "Living With is Required";
    if (!formData.country) newErrors.country = "Country is Required";
    if (!formData.state) newErrors.state = "State is Required";
    if (!formData.city) newErrors.city = "City is Required";
    if (!formData.pincode) newErrors.pincode = "Pin Code is Required";



    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }




  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;


    try {
      const payload = new FormData();
      /// // payload.append('user_id', userId);
      payload.append('id', userId);
      payload.append('desc', formData.description);
      payload.append('sub_caste', (formData.subcaste.value) ? (formData.subcaste.value) : (formData.subcaste));
      payload.append('ms', (formData.maritalStatus.value) ? (formData.maritalStatus.value) : (formData.maritalStatus));
      payload.append('height', (formData.height.value) ? (formData.height.value) : (formData.height));
      payload.append('weight', (formData.weight));
      payload.append('body', (formData.bodyType.value) ? (formData.bodyType.value) : (formData.bodyType));
      payload.append('ps', (formData.physicalStatus.value) ? (formData.physicalStatus.value) : (formData.physicalStatus));
      payload.append('eating', (formData.eatingHabits.value) ? (formData.eatingHabits.value) : (formData.eatingHabits));
      payload.append('drinking', (formData.drinkingHabits.value) ? (formData.drinkingHabits.value) : (formData.drinkingHabits));
      payload.append('smoking', (formData.smokingHabits.value) ? (formData.smokingHabits.value) : (formData.smokingHabits));
      payload.append('hobbies', (Array.isArray(formData.hobbies)) ? (Object.values(formData.hobbies.map(val => (val.value)))) : (formData.hobbies));

      // Object.values(formData.hobbies.map(val=>( val.value)))


      payload.append('curr_location', (formData.currentlocation.value) ? (formData.currentlocation.value) : (formData.currentlocation));
      payload.append('manglik', (formData.manglik.value) ? (formData.manglik.value) : (formData.manglik));


      // ///contact table 
      payload.append('city', (formData.city.value) ? (formData.city.value) : (formData.city));
      payload.append('country', (formData.country.value) ? (formData.country.value) : (formData.country));
      payload.append('state', (formData.state.value) ? (formData.state.value) : (formData.state));
      payload.append('pin', (formData.pincode));

      // ///education Table
      payload.append("highest_edu", (formData.highestEducation.value) ? (formData.highestEducation.value) : (formData.highestEducation));
      payload.append("ug_degree", (formData.educationQualification.value) ? (formData.educationQualification.value) : (formData.educationQualification));
      payload.append("emp_in", (formData.employedIn.value) ? (formData.employedIn.value) : (formData.employedIn));
      payload.append("occupation", (formData.occupation.value) ? (formData.occupation.value) : (formData.occupation));
      payload.append("org_name", (formData.organizationName.value) ? (formData.organizationName.value) : (formData.organizationName));
      payload.append("annual_income", (formData.annualIncome.value) ? (formData.annualIncome.value) : (formData.annualIncome));

      // ///family Table
      payload.append("sister", (formData.sisters.value) ? (formData.sisters.value) : (formData.sisters));
      payload.append("brother", (formData.brothers.value) ? (formData.brothers.value) : (formData.brothers));
      payload.append("gothra", (formData.gothra.value) ? (formData.gothra.value) : (formData.gothra));
      payload.append("gothra_maternal", (formData.maternalGothra.value) ? (formData.maternalGothra.value) : (formData.maternalGothra));
      payload.append("family_status", (formData.familyStatus.value) ? (formData.familyStatus.value) : (formData.familyStatus));
      payload.append("family_type", (formData.familyType.value) ? (formData.familyType.value) : (formData.familyType));
      payload.append("family_based", (formData.familyBelongsTo.value) ? (formData.familyBelongsTo.value) : (formData.familyBelongsTo));
      payload.append("living_wth_parents", (formData.livingWithParents.value) ? (formData.livingWithParents.value) : (formData.livingWithParents));


      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}Register_controller/updateProfileData`,
        payload
      );

      if (response.data.response == "success") {
        ////// use context api
        ///// setUserId(response.data.id);
        navigate('/view-profile/' + userId);
      }

    } catch (error) {
      console.log('Error While Posting Data:', error);
    }
  };

  if (isLoading) {
    return (<div className='custom-loader-g'><div class="spinner-border text-danger" role="status"><span class="sr-only">Loading...</span></div></div>);
  }

  // if (error) {
  //   return <div className="error">Error: {error}</div>;
  // }

  return (

    <>
      <Header></Header>


      <div className='create-profile-wrapper'>
        <div className='container pt-4'>
          <div className="create-profile-container" style={{ borderRadius: "1rem", boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)" }}>
            {/* Left Side Form */}
            <div className="create-profile-form-side py-4">
              <h1 className="create-profile-heading mb-0 text-center">Edit Profile</h1>
              {/* <p className="create-profile-subheading">Start your journey here</p> */}
              <h3 className="form-section-title my-0 text-center">Basic Details</h3>

              <form className="create-profile-form" onSubmit={handleSubmit}>
                {/* Section 1: Basic Details */}

                <div className="form-group">
                  <label className="form-label">Description</label>
                  <textarea
                    rows={6}
                    className="form-textarea"
                    name="description"
                    placeholder="Write something about yourself..."
                    value={(formData.description) ? formData.description : APIformData.desc}
                    onChange={handleInputChange}
                  />
                  {errors.description && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.description}</span>}

                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Sub Caste</label>
                    <Select
                      options={options?.subCaste?.map(caste => ({
                        label: caste,
                        value: caste
                      }))}
                      value={(formData.subcaste.value) ? (formData.subcaste) : ({ label: formData.subcaste, value: formData.subcaste })}
                      onChange={(selected) => handleSelectChange("subcaste", selected)}
                      placeholder="Select Sub Caste"
                    />
                    {errors.subcaste && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.subcaste}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Current Location *</label>
                    <Select
                      options={options?.countries?.map(country => ({
                        label: country,
                        value: country
                      }))}
                      value={(formData.currentlocation.value) ? (formData.currentlocation) : ({ label: formData.currentlocation, value: formData.currentlocation })}

                      onChange={(selected) => handleSelectChange("currentlocation", selected)}
                      placeholder="Select Country"
                      isDisabled={options.countries.length === 0}
                    />
                    {errors.currentlocation && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.currentlocation}</span>}

                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Manglik Dosha</label>



                    <Select
                      options={["Yes", "No"].map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.manglik.value) ? (formData.manglik) : ({ label: formData.manglik, value: formData.manglik })}
                      onChange={(selected) => handleSelectChange("manglik", selected)}
                      placeholder="Select Maglik"

                    />
                    {errors.manglik && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.manglik}</span>}


                  </div>
                  <div className="form-group">
                    <label className="form-label">Marital Status *</label>


                    <Select
                      options={["Single", "Divorce", "Widowed"].map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.maritalStatus.value) ? (formData.maritalStatus) : ({ label: formData.maritalStatus, value: formData.maritalStatus })}
                      onChange={(selected) => handleSelectChange("maritalStatus", selected)}
                      placeholder="Select Marital Status"

                    />
                    {errors.maritalStatus && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.maritalStatus}</span>}

                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Height (in feet) *</label>


                    <Select
                      options={Array.from({ length: 4 }, (_, f) => 4 + f) // 4 to 7
                        .flatMap(feet =>
                          Array.from({ length: 12 }, (_, inches) => {
                            if (feet === 7 && inches > 0) return null;
                            return { label: `${feet}.${inches} Ft`, value: `${feet}.${inches}` }
                          }).filter(Boolean)
                        )}
                      value={(formData.height.value) ? (formData.height) : ({ label: `${formData.height} Ft`, value: formData.height })}
                      onChange={(selected) => handleSelectChange("height", selected)}
                      placeholder="Select Height"

                    />
                    {errors.height && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.height}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Weight (in Kg)</label>

                    <Select
                      options={[...Array.from({ length: 111 }, (_, i) => i + 40).map(val => ({ label: `${val} Kg`, value: `${val}` })), { label: `150+ Kg`, value: `150+` }]}

                      value={(formData.weight.value) ? (formData.weight) : ({ label: `${formData.weight} Kg`, value: formData.weight })}
                      onChange={(selected) => handleSelectChange("weight", selected)}
                      placeholder="Select Weight"
                    />
                    {errors.weight && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.weight}</span>}
                  </div>
                </div>


                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Body Type *</label>


                    <Select
                      options={Array("Slim", "Average", "Athletic", "Heavy").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.bodyType.value) ? (formData.bodyType) : ({ label: formData.bodyType, value: formData.bodyType })}
                      onChange={(selected) => handleSelectChange("bodyType", selected)}
                      placeholder="Select Body Type"
                    />
                    {errors.bodyType && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.bodyType}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Physical Status : *</label>



                    <Select
                      options={Array("Normal", "Physically Challenged").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.physicalStatus.value) ? (formData.physicalStatus) : ({ label: formData.physicalStatus, value: formData.physicalStatus })}
                      onChange={(selected) => handleSelectChange("physicalStatus", selected)}
                      placeholder="Select Physical Status"
                    />
                    {errors.physicalStatus && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.physicalStatus}</span>}

                  </div>
                </div>


                <div className="form-row">

                  <div className="form-group">
                    <label className="form-label">Eating Habits : </label>


                    <Select
                      options={Array("Vegetarian", "Non-Vegetarian", "Jain", "Eggetarian").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.eatingHabits.value) ? (formData.eatingHabits) : ({ label: formData.eatingHabits, value: formData.eatingHabits })}
                      onChange={(selected) => handleSelectChange("eatingHabits", selected)}
                      placeholder="Select Eating Habits"
                    />
                    {errors.eatingHabits && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.eatingHabits}</span>}

                  </div>

                  <div className="form-group">
                    <label className="form-label">Drinking Habits : </label>


                    <Select
                      options={Array("Yes", "No", "Occasionally").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.drinkingHabits.value) ? (formData.drinkingHabits) : ({ label: formData.drinkingHabits, value: formData.drinkingHabits })}
                      onChange={(selected) => handleSelectChange("drinkingHabits", selected)}
                      placeholder="Select Drinking Habits"
                    />

                    {errors.drinkingHabits && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.drinkingHabits}</span>}



                  </div>

                </div>



                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Smoking Habits : </label>



                    <Select
                      options={Array("Yes", "No", "Occasionally").map(val => ({
                        label: val,
                        value: val
                      }))}

                      value={(formData.smokingHabits.value) ? (formData.smokingHabits) : ({ label: formData.smokingHabits, value: formData.smokingHabits })}
                      onChange={(selected) => handleSelectChange("smokingHabits", selected)}
                      placeholder="Select Smoking Habits"
                    />

                    {errors.smokingHabits && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.smokingHabits}</span>}

                  </div>
                </div>


                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Hobbies : </label>




                    <Select

                      options={[
                        {
                          label: "Creative & Artistic",
                          options: [
                            { value: "drawing", label: "Drawing" },
                            { value: "painting", label: "Painting" },
                            { value: "writing", label: "Writing" },
                            { value: "photography", label: "Photography" },
                            { value: "calligraphy", label: "Calligraphy" },
                            { value: "scrapbooking", label: "Scrapbooking" },
                            { value: "sewing", label: "Sewing" },
                            { value: "knitting", label: "Knitting" },
                            { value: "crocheting", label: "Crocheting" },
                            { value: "woodworking", label: "Woodworking" },
                            { value: "metalworking", label: "Metalworking" },
                            { value: "lego", label: "LEGO Building" },
                            { value: "model_building", label: "Model Building" },
                            { value: "home_decor", label: "Home Decor" },
                            { value: "interior_design", label: "Interior Design" },
                          ],
                        },
                        {
                          label: "Performance & Entertainment",
                          options: [
                            { value: "dancing", label: "Dancing" },
                            { value: "singing", label: "Singing" },
                            { value: "playing_music", label: "Playing Musical Instruments" },
                            { value: "acting", label: "Acting" },
                            { value: "magic", label: "Magic Tricks" },
                            { value: "vlogging", label: "Vlogging" },
                            { value: "podcasting", label: "Podcasting" },
                            { value: "blogging", label: "Blogging" },
                          ],
                        },
                        {
                          label: "Outdoor & Physical",
                          options: [
                            { value: "hiking", label: "Hiking" },
                            { value: "camping", label: "Camping" },
                            { value: "fishing", label: "Fishing" },
                            { value: "gardening", label: "Gardening" },
                            { value: "cycling", label: "Cycling" },
                            { value: "running", label: "Running" },
                            { value: "swimming", label: "Swimming" },
                            { value: "yoga", label: "Yoga" },
                            { value: "meditation", label: "Meditation" },
                            { value: "surfing", label: "Surfing" },
                            { value: "skateboarding", label: "Skateboarding" },
                            { value: "skiing", label: "Skiing" },
                            { value: "snowboarding", label: "Snowboarding" },
                            { value: "horseback_riding", label: "Horseback Riding" },
                            { value: "archery", label: "Archery" },
                            { value: "martial_arts", label: "Martial Arts" },
                          ],
                        },
                        {
                          label: "Tech & Digital",
                          options: [
                            { value: "gaming", label: "Gaming" },
                            { value: "coding", label: "Coding" },
                            { value: "robotics", label: "Robotics" },
                            { value: "3d_printing", label: "3D Printing" },
                            { value: "investing", label: "Investing" },
                            { value: "language_learning", label: "Learning Languages" },
                          ],
                        },
                        {
                          label: "Culinary",
                          options: [
                            { value: "cooking", label: "Cooking" },
                            { value: "baking", label: "Baking" },
                          ],
                        },
                        {
                          label: "Mind & Collection",
                          options: [
                            { value: "reading", label: "Reading" },
                            { value: "puzzles", label: "Puzzles" },
                            { value: "board_games", label: "Board Games" },
                            { value: "collecting_stamps", label: "Stamp Collecting" },
                            { value: "collecting_coins", label: "Coin Collecting" },
                            { value: "birdwatching", label: "Birdwatching" },
                            { value: "bird_breeding", label: "Bird Breeding" },
                            { value: "geocaching", label: "Geocaching" },
                            { value: "astrology", label: "Astrology" },
                            { value: "astronomy", label: "Astronomy" },
                          ],
                        },
                        {
                          label: "Media & Entertainment",
                          options: [
                            { value: "movies", label: "Watching Movies" },
                            { value: "tv_series", label: "Watching TV Series" },
                            { value: "anime", label: "Watching Anime" },
                            { value: "traveling", label: "Traveling" },
                          ],
                        },
                        {
                          label: "Community & Social",
                          options: [
                            { value: "volunteering", label: "Volunteering" },
                          ],
                        }
                      ]}

                      isMulti={true}
                      value={(Array.isArray(formData.hobbies)) ? (formData.hobbies) : (formData?.hobbies?.split(",")?.map(h => ({ label: h.trim().slice(0, 1).toUpperCase() + h.trim().slice(1, h.trim().length), value: h.trim() })))}
                      onChange={(selected) => handleSelectChange("hobbies", selected)}
                      placeholder="Select Hobbies"
                    />


                    {errors.hobbies && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.hobbies}</span>}


                  </div>


                </div>








                {/* Section 2: Education & Career */}
                <h3 className="form-section-title text-center my-2">Education & Career</h3>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Highest Education *</label>

                    <Select
                      options={Array("Not Educated", "10th Pass", "12th Pass", "Diploma", "Graduate", "M Phil", "PHD", "Other").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.highestEducation.value) ? (formData.highestEducation) : ({ label: formData.highestEducation, value: formData.highestEducation })}
                      onChange={(selected) => handleSelectChange("highestEducation", selected)}
                      placeholder="Select Highest Education"
                    />


                    {errors.highestEducation && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.highestEducation}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Education Qualification</label>

                    <Select
                      options={options?.education?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.educationQualification.value) ? (formData.educationQualification) : ({ label: formData.educationQualification, value: formData.educationQualification })}
                      onChange={(selected) => handleSelectChange("educationQualification", selected)}
                      placeholder="Select Qualtification"
                    />


                    {errors.educationQualification && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.educationQualification}</span>}

                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Occupation *</label>


                    <Select
                      options={options?.occupation?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.occupation.value) ? (formData.occupation) : ({ label: formData.occupation, value: formData.occupation })}
                      onChange={(selected) => handleSelectChange("occupation", selected)}
                      placeholder="Select Occupation"
                    />


                    {errors.occupation && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.occupation}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Employed In</label>


                    <Select
                      options={Array("Private Sector", "Government / Puboptionc Sector", "Civil Services", "Defence", "Self- Employed", "Unemployed").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.employedIn.value) ? (formData.employedIn) : ({ label: formData.employedIn, value: formData.employedIn })}
                      onChange={(selected) => handleSelectChange("employedIn", selected)}
                      placeholder="Select Employed In"
                    />


                    {errors.employedIn && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.employedIn}</span>}
                  </div>
                </div>


                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Annual Income *</label>

                    <Select
                      options={options?.income?.map((val, index) => ({
                        label: val,
                        value: parseInt(index + 1)
                      }))}
                      value={(formData.annualIncome.value) ? (formData.annualIncome) : ({ label: (APIformData.income), value: parseInt(formData.annualIncome) })}
                      onChange={(selected) => handleSelectChange("annualIncome", selected)}
                      placeholder="Select Income"
                    />


                    {errors.annualIncome && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.annualIncome}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Company Name</label>

                    <input name="organizationName" className='form-control' onChange={handleInputChange} value={(formData.organizationName) ? (formData.organizationName) : (APIformData.org_name)} type='Text' />

                  </div>
                </div>

                {/* Section 3: Family Details */}
                <h3 className="form-section-title text-center my-2">Family Details</h3>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Sister(s)</label>

                    <Select
                      options={Array('0', '1', '2', '3', '3+').map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.sisters.value) ? (formData.sisters) : ({ label: formData.sisters, value: formData.sisters })}
                      onChange={(selected) => handleSelectChange("sisters", selected)}
                      placeholder="Select Sister"
                    />


                    {errors.sisters && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.sisters}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Brother(s)</label>


                    <Select
                      options={Array('0', '1', '2', '3', '3+').map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.brothers.value) ? (formData.brothers) : ({ label: formData.brothers, value: formData.brothers })}
                      onChange={(selected) => handleSelectChange("brothers", selected)}
                      placeholder="Select Brothers"
                    />


                    {errors.brothers && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.brothers}</span>}


                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Gothra</label>
                    <Select
                      options={options.gothra.map((k) => ({ label: Object.values(k), value: parseInt(Object.keys(k)) }))}
                      value={(formData.gothra.value) ? (formData.gothra) : ({ label: APIformData.gothraname, value: parseInt(formData.gothra) })}
                      onChange={(selected) => handleSelectChange("gothra", selected)}
                      placeholder="Select Gothra"
                      isDisabled={options.gothra.length === 0}
                    />

                    {errors.gothra && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.gothra}</span>}
                  </div>
                  <div className="form-group">
                    <label className="form-label">Gothra (Maternal)</label>
                    <Select
                      options={options.gothra.map((k) => ({ label: Object.values(k), value: parseInt(Object.keys(k)) }))}
                      value={(formData.maternalGothra.value) ? (formData.maternalGothra) : ({ label: APIformData.gothramaternalname, value: parseInt(formData.maternalGothra) })}
                      onChange={(selected) => handleSelectChange("maternalGothra", selected)}
                      placeholder="Select Maternal Gothra"
                      isDisabled={options.gothra.length === 0}
                    />


                    {errors.maternalGothra && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.maternalGothra}</span>}
                  </div>
                </div>




                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Family Status</label>


                    <Select
                      options={Array("Rich/Affluent", "Upper Middle", "Middle Class").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.familyStatus.value) ? (formData.familyStatus) : ({ label: formData.familyStatus, value: formData.familyStatus })}
                      onChange={(selected) => handleSelectChange("familyStatus", selected)}
                      placeholder="Select Family Status"
                    />

                    {errors.familyStatus && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.familyStatus}</span>}



                  </div>
                  <div className="form-group">
                    <label className="form-label">Family Type</label>

                    <Select
                      options={Array("Joint Family", "Nuclear Family").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.familyType.value) ? (formData.familyType) : ({ label: formData.familyType, value: formData.familyType })}
                      onChange={(selected) => handleSelectChange("familyType", selected)}
                      placeholder="Select Family Type"
                    />

                    {errors.familyType && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.familyType}</span>}



                  </div>
                </div>



                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label">Family Belongs To </label>
                    <Select
                      options={options?.states?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.familyBelongsTo.value) ? (formData.familyBelongsTo) : ({ label: formData.familyBelongsTo, value: formData.familyBelongsTo })}
                      onChange={(selected) => handleSelectChange("familyBelongsTo", selected)}
                      placeholder="Select Family Belongs To"


                    />



                    {errors.familyBelongsTo && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.familyBelongsTo}</span>}

                  </div>
                  <div className="form-group">
                    <label className="form-label">Living with parents?</label>

                    <Select
                      options={Array("Yes", "No", "Not Applicable").map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.livingWithParents.value) ? (formData.livingWithParents) : ({ label: formData.livingWithParents, value: formData.livingWithParents })}
                      onChange={(selected) => handleSelectChange("livingWithParents", selected)}
                      placeholder="Select Living With Parents"
                    />

                    {errors.livingWithParents && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.livingWithParents}</span>}



                  </div>
                </div>





                <div className="form-row">

                  <div className="form-group">
                    <label className="form-label">Country</label>

                    <Select
                      options={options?.countries?.map(val => ({
                        label: val,
                        value: val
                      }))}
                      value={(formData.country.value) ? (formData.country) : ({ label: formData.country, value: formData.country })}
                      onChange={(selected) => handleSelectChange("country", selected)}
                      placeholder="Select Country"
                      defaultValue={{ label: "India", value: "India" }}
                    />


                    {errors.country && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.country}</span>}

                  </div>

                  <div className="form-group">
                    <label className="form-label">Current State *</label>
                    <Select
                      options={options.states.map(state => ({
                        label: state,
                        value: state
                      }))}
                      value={(formData.state.value) ? (formData.state) : ({ label: formData.state, value: formData.state })}
                      onChange={(selected) => handleSelectChange("state", selected)}
                      placeholder="Select State"
                      isDisabled={options.states.length === 0}
                    />


                    {errors.state && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.state}</span>}
                  </div>

                </div>


                <div className="form-row">

                  <div className="form-group">
                    <label className="form-label">Current City</label>
                    <Select
                      options={options.cities.map(city => ({
                        label: city,
                        value: city
                      }))}
                      value={(formData.city.value) ? (formData.city) : ({ label: formData.city, value: formData.city })}
                      onChange={(selected) => handleSelectChange("city", selected)}
                      placeholder="Select City"
                      isDisabled={options.cities.length === 0}
                    />


                    {errors.city && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.city}</span>}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Pin Code *</label>
                    <input type='text' className='form-control' name='pincode' onChange={handleInputChange} value={(formData.pincode) ? (formData.pincode) : APIformData.pin} />

                    {errors.pincode && <span className="field-error" style={{ color: 'red', fontSize: '12px' }}>{errors.pincode}</span>}
                  </div>


                </div>

                <button type="submit" className="create-btn mt-3">Update</button>
              </form>
            </div>

            {/* Right Side Image */}
            <div className="create-profile-image-side position-relative d-none d-lg-block">
              <img src={coupleImage} alt="Couple" className="couple-image" />
              <div className="image-overlay position-absolute" style={{ bottom: "50px" }}>
                <h2 className="overlay-heading">
                  Your Journey To Love Begins <span className="highlight">Here!</span>
                </h2>
                <p className="overlay-text">
                  Connect With Genuine Matches <br/> Who Share Your <span className="highlight">Values</span> And <span className="highlight">Dreams</span>.
                </p>
              </div>
            </div>
          </div>
        </div>

        <style>
          {`
        /* Main Layout */
           .css-b62m3t-container{
margin-top:0 !important;
           }
        .form-group select,.form-group input
        {
        background:white;
        border-radius:15px;
        }
        .create-profile-wrapper {
          min-height: 100vh;
          background-color: #fff;
        }

        .create-profile-logo {
          max-width: 180px;
          margin: 20px;
        }

        .create-profile-container {
          display: flex;
          height: calc(100vh - 80px);
          overflow: hidden;
        }

        /* Form Side Styles */
        .create-profile-form-side {
          width: 60%;
          padding: 40px;
          overflow-y: auto;
          background-color: #fff;
        }

        .create-profile-heading {
          font-size: 2rem;
          color: #333;
          margin-bottom: 0.5rem;
        }

        .create-profile-subheading {
          color: #666;
          margin-bottom: 2rem;
          font-size: 1rem;
        }

        .create-profile-form {
          display: flex;
          flex-direction: column;
          gap:0 1.5rem;
        }

        .form-section-title {
          margin-top: 2rem;
          color: #E53D5C;
          font-size: 1.3rem;
          font-weight: 600;
        }

        /* Form Elements */
        .form-group {
          display: flex;
          flex-direction: column;
          gap:3px 0.5rem;
        }

        .form-label {
          font-size: 0.9rem;
          font-weight: 500;
          color: #333;
        }

        .form-input,
        .form-select,
        .form-textarea {
          padding: 0.8rem;
          border-radius: 6px;
          border: 1px solid #ccc;
          font-size: 1rem;
          transition: border-color 0.2s;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #E53D5C;
        }

        .form-textarea {
          min-height: 100px;
          resize: vertical;
        }

        .form-row {
          display: flex;
          gap:3px 1.5rem;
        }

        .form-row > .form-group {
          flex: 1;
        }

        /* Image Side Styles */
        .create-profile-image-side {
          width: 40%;
          position: relative;
          background-color: #F8E1E7;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .couple-image {
          width: 100%;
          height:100%;
          margin-bottom: 20px;
        }

        .image-overlay {
          text-align: center;
          max-width: 400px;

        }

        .overlay-heading {
          font-size: 1.8rem;
          color: #fff;
          margin-bottom: 1rem;
          line-height: 1.3;
          font-weight:bold;
        }

        .overlay-text {
          font-size: 1rem;
          color: #fff;
          line-height: 1.6;
                    font-weight:bold;

        }

        .highlight {
          color: #ffc107;
          font-weight: 600;
        }

        .create-btn {
          padding: 12px;
          background-color: #ff4d6d;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: bold;
          cursor: pointer;
          width: 100%;
          margin-top: 2rem;
        }

        .loading, .error {
          padding: 2rem;
          text-align: center;
          font-size: 1.2rem;
        }

        .error {
          color: #E53D5C;
        }

        /* Responsive styles */
        @media (max-width: 768px) {
          .create-profile-container {
            flex-direction: column;
            height: auto;
          }
          
          .create-profile-form-side,
          .create-profile-image-side {
            width: 100%;
          }
          
          .form-row {
            flex-direction: column;
            gap:3px 1rem;
          }
            .css-13cymwt-control {
            border-color: #dee2e6 !important ;
            }
          .css-13cymwt-control:hover {
            border-color: #dee2e6 !important ;
            }
        }


        @media (max-width:700px){
        .create-profile-form-side{
        padding:0 15px
        }
        }



        `}
        </style>
      </div>

      <Footer></Footer>

    </>
  );
};

export default EditProfile;